'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _analyticsTraffic = require('./analytics-traffic.html');

var _analyticsTraffic2 = _interopRequireDefault(_analyticsTraffic);

var _analyticsTraffic3 = require('./analytics-traffic.controller');

var _analyticsTraffic4 = _interopRequireDefault(_analyticsTraffic3);

require('./analytics-traffic.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var analyticsComponent = {
  restrict: 'E',
  bindings: {},
  template: _analyticsTraffic2.default,
  controller: _analyticsTraffic4.default,
  controllerAs: 'vm'
};

exports.default = analyticsComponent;


/** WEBPACK FOOTER **
 ** ./client/app/containers/analytics-traffic/analytics-traffic.component.js
 **/